import React from 'react';
import { RequiredSymbol } from '../../scenes/Form/components/common';
import { STAGE } from './api';

const STB_WEBSITE_FILINGS_PAGE = STAGE === "prod" ? "https://prod.stb.gov/proceedings-actions/filings/" : "https://int.stb.gov/proceedings-actions/filings/";

export const ADD_PARTY_BUTTON_LABEL = 'Add Additional Party';
export const ADD_ATTACHMENT_BUTTON_LABEL = 'Add Additional Attachment';
export const SUBMIT_FORMAL_BUTTON_LABEL = 'Submit Formal Filing';
export const SUBMIT_INFORMAL_BUTTON_LABEL = 'Submit';
export const CHOOSE_FILE_BUTTON_LABEL = 'Choose File';
export const ADD_EMAIL_BUTTON_LABEL = "Add Email";
export const ADD_DOCKET_NUMBER_LABEL = "Add Docket Number";
export const REMOVE_BUTTON_LABEL = "Remove";
export const OPTIONAL_PLACEHOLDER = "optional";
export const PAGE_NOT_FOUND_TEXT = 'Page Not Found';
export const ENHANCED_SEARCH_BUTTON_LABEL = "Enhanced Search";
export const CONTINUE_BUTTON_LABEL = "Continue";

export const EFILING_TITLE = 'Filing Information';
export const EFILING_DESCRIPTION = (
	<span>
		In order for the Office of Proceedings to process your submission, please fill out the following information. An asterisk (*) indicates a required field. <br/>
		PLEASE NOTE:
		<ul>
			<li>By submitting your document as a public filing, you consent to have your document shared publicly.  If you include business or personal contact information when entering party or submitter information, this information will be publicly available on the Board’s website.</li>
			<li>Publicly available personal contact information includes, but is not limited to, the filer’s name, home address, telephone number and email address.  For any issues regarding e-filing, please call (202) 245-0350.</li>
			<li>We encourage you to provide business contact information where possible.</li>
		</ul>
	</span>
);
export const INFORMAL_FILING_TITLE = 'Filing Information';
export const INFORMAL_FILING_DESCRIPTION = (
	<span>
		In order for the Office of Proceedings to process your submission, please fill out the following information. An asterisk (*) indicates a required field. <br/>
		PLEASE NOTE:
		<ul>
			<li>By submitting your document as a public filing, you consent to have your document shared publicly.  If you include business or personal contact information when entering party or submitter information, this information will be publicly available on the Board’s website.</li>
			<li>Publicly available personal contact information includes, but is not limited to, the filer’s name, home address, telephone number and email address.  For any issues regarding e-filing, please call (202) 245-0350.</li>
			<li>We encourage you to provide business contact information where possible.</li>
		</ul>
	</span>
);
export const PARTY_SECTION_TITLE = 'Party Information';
export const PARTY_SECTION_DESCRIPTION =
	'If this is a Joint Filing, add additional parties by clicking on the button below.';

export const FILE_SECTION_TITLE = 'File Formats/Documents that we Accept';
export const FILE_FORMATS_TITLE =
	'The STB accepts electronically all documents routinely filed in paper except large evidentiary filings (over 100 MB). The STB accepts the following formats:';
export const FORMAL_FILE_FORMATS_TITLE =
	'The STB accepts electronically all documents routinely filed in paper except large evidentiary filings (over 500 MB). The STB accepts the following formats:';
export const ENVCOM_FILE_FORMATS_TITLE = 'The STB accepts electronically all documents routinely filed in paper except large files (over 500 MB). The STB accepts the following formats:';
export const ACCEPTED_FORMATS = [
	'Microsoft Word (doc, docx)',
	'Microsoft Excel (xls, xlsx)',
	'Adobe Acrobat (pdf)',
	'Media Files (gif, jpg, png, mpg, etc.)',
	'Zip files containing no .exe files'
];

export const ACCEPTED_FORMATS_FORMAL = [
	'Microsoft Word (doc, docx)',
	'Microsoft Excel (xls, xlsx)',
	'Adobe Acrobat (pdf)',
	'Media Files (gif, jpg, png, mpg, etc.)',
	'Map Files (kml and kmz)',
	'Shapefiles (cpg, dbf, prj, shp, shx)',
	'Zip files containing no .exe files'
];

export const ACCEPTED_FORMATS_ENVCOM = [
	'Microsoft Word (doc, docx)',
	'Microsoft Excel (xls, xlsx)',
	'Adobe Acrobat (pdf)',
	'Media Files (gif, jpg, png, mpg, etc.)',
	'Map Files (kml and kmz)',
	'Zip files containing no .exe files'
];
export const SUBMISSION_REQS_TITLE = 'Submission Requirements: ';

export const ATTACHMENTS_LABEL = 'Attachment(s):';
export const ATTACHMENT_LABEL = 'Attachment:';

const FILE_REQS_NAME_150_CHARS = 'File names are limited to 150 characters';
const FILE_REQS_SIZE_100_MB = 'Each file must be no larger than 100 MB';
const FILE_REQS_SIZE_500_MB = 'Each file must be no larger than 500 MB';
const FILE_REQS_CORRECT_EXTENSION = 'Use the correct file name extension';
const FILE_REQS_NAME_EXAMPLE = (
	<span>
		<strong>
			File names can <u>only</u> have letters, numbers, and underscores. Spaces and special characters are <u>not</u> compatible with the e-filing system and their use will result in e-filing failure.
		</strong>
		<ul>
			<li>Example: “STB_ReplytoComment.pdf” (Acceptable)</li>
			<li>Example: “STB Reply*to*Comment.pdf” (Not Acceptable due to space and special characters)</li>
		</ul>
	</span>
);

export const SUBMISSION_REQUIREMENTS = [
	FILE_REQS_NAME_150_CHARS,
	FILE_REQS_SIZE_100_MB,
	FILE_REQS_CORRECT_EXTENSION,
	FILE_REQS_NAME_EXAMPLE
];

export const SUBMISSION_REQUIREMENTS_FORMAL = [
	FILE_REQS_NAME_150_CHARS,
	FILE_REQS_SIZE_500_MB,
	FILE_REQS_CORRECT_EXTENSION,
	FILE_REQS_NAME_EXAMPLE
];

export const SUBMISSION_REQUIREMENTS_RECORDATIONS = [
	'The file must be a PDF',
	...SUBMISSION_REQUIREMENTS
];

export const SUBMISSION_REQUIREMENTS_ENVCOM = [
	FILE_REQS_NAME_150_CHARS,
	FILE_REQS_SIZE_500_MB,
	FILE_REQS_CORRECT_EXTENSION,
	'A maximum of 4 attachments are allowed (If you have more than 4 attachments, consider combining files into a PDF and images, shapefiles, or other file types into a zip file)',
	FILE_REQS_NAME_EXAMPLE
];

export const EQUIPMENT_DESCRIPTION_COLUMN_MAX = 500;
export const ENVIRONMENTAL_COMMENTS_COLUMN_MAX = 100;

export const RECORDATION_INFO_INTRO = (
	<span>
		In order for the Office of Proceedings to process your submission, please fill out the following information. An asterisk (*) indicates a required field. <br/>
		PLEASE NOTE:
		<ul>
			<li>By submitting your document as a public filing, you consent to have your document shared publicly.  If you include business or personal contact information when entering party or submitter information, this information will be publicly available on the Board’s website.</li>
			<li>Publicly available personal contact information includes, but is not limited to, the filer’s name, home address, telephone number and email address.  For any issues regarding e-filing, please call (202) 245-0350.</li>
			{/* <li>E-filers must pay the filing fee on Pay.gov.</li> */}
			<li>We encourage you to provide business contact information where possible.</li>
		</ul>
	</span>
);
export const RECORDATION_INFO_NOTICE = <><span style={{color: "rgb(255, 0, 0)"}}>{"NOTICE: FEE INCREASE EFFECTIVE September 29, 2023."}</span></>;
export const RECORDATION_INFO_FEE = <><span>{"The filing of documents for recordation (49 U.S.C. § 11301 and 49 C.F.R. § 1177.3(c)) will be "}<span style={{color: "rgb(255, 0, 0)"}}>{"$54.00"}</span>{" per document."}</span></>;
export const RECORDATION_INFO_INSTRUCTIONS = "You should receive an email acknowledging receipt of your recordation. Documents received after 5:00 p.m. Eastern Time may not be processed until the next business day. Once your recordation has been formally accepted by the Board, the recordation will be placed on the Recordations page of the Board’s website. If the recordation is time-sensitive, please call 202-245-0350.";

export const RECORDATION_INFO_NO_CRS = "There are no cross references for this Recordation";
export const RECORDATION_INFO_NO_PARTIES = "There are no parties for this Recordation";

export const RCPA_INFO = "You will receive a confirmation email acknowledging receipt of your request after submitting the form below.";

export const ENV_COMMENT_INFO = (
	<span>
		In order for the Office of Environmental Analysis to process your submission, please fill out the following information. An asterisk (*) indicates a required field. <br/>
		PLEASE NOTE:
		<ul>
			<li>By submitting your document, you consent to have your document shared publicly.  If a submitter includes business or personal contact information within that document or in the “Environmental Comments” field, this information will be publicly available on the Board’s website.</li>
			<li>Publicly available personal contact information includes the submitter’s name, city, and state.  For any issues regarding e-filing of environmental comments, please call (202) 245-0350.</li>
			<li>We encourage you to provide business contact information where possible.</li>
		</ul>
	</span>
);

export const DEFAULT_FILENAME = 'Attachment';

export const PAY_GOV_HELP_TEXT = 'When entering the "Fee Type Number" field on the Pay.gov website and your submission has no prior associated recordation, then enter "Primary". When submitting a secondary Recordation, then enter the associated recordation number.'

export const DATA_TABLE_TAB_LABEL = 'Data Table';
export const ASSOCIATED_TAB_LABEL = 'Associated';
export const DOCKET_ACTIONS_LABEL = 'Docket Actions of';
export const SEARCH_RESULTS_LABEL = 'Results:';
export const NO_RESULTS_FOUND_TEXT = 'No results found';

export const NETWORK_ERROR_ID = 'network-error';

export const LOADING_TITLE = "Loading";

export const ATTACHMENTS_ERROR_ID = 'attachments';
export const ATTACHMENTS_DIV_ID = "attachments-root";
export const PARTY_DIV_ID = 'partydiv';
export const NO_MAILING_LIST_LABEL = 'No mailing list to display.';
export const CHAR_COUNT_ID = "charCount";

export const ACTIVE_CLASS_NAME = 'active';
export const CLICK_TO_EXPAND_TEXT = 'Click to expand';
export const CLICK_TO_COLLAPSE_TEXT = 'Click to collapse';
export const CURRENT_PAGE_ITEM_ID = 'current_page_item';
export const CHILDREN_COMPONENT_PROPERTY = 'children';
export const REGION_HINT_ID = 'region_hint';
export const OPEN_RECORDATION_TITLE = 'Open Recordation';

export const DATE_DISPLAYED_REGION = 'en-US';
export const DATE_DISPLAYED_TIMEZONE = 'America/New_York';

export const CONFIRMATION_TITLE = "Thank you for your submission";
export const CONFIRMATION_TEXT = "Submissions that will appear on the Surface Transportation Board’s website will be posted after they are processed during regular business hours. If you have any questions, please contact us at (202) 245-0350.";
export const CONFIRMATION_TEXT_RCPA = <span>Thank you for your submission to the Surface Transportation Board’s Rail Customer and Public Assistance (RCPA) office.  If you have requested informal assistance from RCPA, a staff member will contact you shortly.  RCPA can be reached at (202) 245-0238 or <a href="mailto:rcpa@stb.gov">rcpa@stb.gov</a>.</span>;
export const CONFIRMATION_TEXT_ENV_COMM = "Your environmental comment has been submitted. For any issues regarding environmental comments, please call (202) 245-0301.";

export const EFILING_QUESTION_TEXT_1 = "Formal filings require service on parties. Prepare your submission in the same manner as you would if filing by paper. All documents in a formal filing must include the docket number(s) applicable to the submission, as well as the name and address of the person responsible for the filing. In addition, formal filings must be submitted as a PDF document and, if available, in the original electronic document format.";
export const EFILING_QUESTION_TEXT_2 = "Please note that unless the parties agree otherwise, you may not serve your filing by email; service of paper copies is required, and service must be accomplished in the manner prescribed by applicable regulations.";
export const EFILING_QUESTION_TEXT_3 = "Files up to 500 MB in size can be accepted as attachments. Attachments over 500 MB cannot be e-filed. ";
export const EFILING_QUESTION_TEXT_4 = <span>Documents received after 5:00 p.m. Eastern Time may not be processed until the next business day.  Once your filing has been formally accepted by the Board, the public version of the filing will be placed on the <a href={STB_WEBSITE_FILINGS_PAGE} target="_parent">Filings</a> page of the Board’s website.</span>;
export const EFILING_QUESTION_TEXT_5 = "By utilizing the e-filing system, you are consenting to e-service of Board decisions and communications. On the following page you will be required to list the email address(es) to be used for e-service. ";
export const EFILING_QUESTION_TEXT_6 = <span>Please add the email address <strong>eservice@stb.gov</strong> to the email contact information for any email address at which you expect to receive e-service of Board decisions. This will help prevent emails from those addresses being sent to junk mail folders.</span>;
export const EFILING_QUESTION_CHECKBOX_TITLE = <span>Formal service upon all parties of record on the service list must be made in accordance with 49 C.F.R. § 1104.12. A sample certificate of service is provided at 49 C.F.R. § 1104.12(c).<RequiredSymbol /></span>;
export const EFILING_QUESTION_CHECKBOX_LABEL = "Yes, I have complied with the Board's service requirements.";

export const EFILNG_SUBMIT_CHECKBOX_LABEL = "I understand that business or personal information (e.g., address, telephone number and email address) that is provided within my submitted document or as contact information will be published and publicly available on the Board’s website with the posting of the submission.";
export const ENVCOM_SUBMIT_CHECKBOX_LABEL = "I understand that business or personal information (e.g., address, telephone number and email address) that is provided within my document or in the “Environmental Comments” field will be published and publicly available on the Board’s website with the posting of the submission.";